import { render, staticRenderFns } from "./IOSCalendar.vue?vue&type=template&id=accaec2c"
import script from "./IOSCalendar.vue?vue&type=script&lang=js"
export * from "./IOSCalendar.vue?vue&type=script&lang=js"
import style0 from "./IOSCalendar.vue?vue&type=style&index=0&id=accaec2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports